<template>  
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
    <v-flex xs6 class="inline-block px-4">      
      <v-text-field hide-details :label="$t('Admin.Role.Form.Surname')" v-model="rol_libelle" />            
      <v-text-field hide-details :label="$t('Admin.Role.Form.Key')" v-model="rol_key" />            
    </v-flex>                         
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminRoleForm'
})
export default class AdminRoleForm extends Vue {  
  

  get modified(){
    return this.$store.myGetters.modifiedAdmRole
  }
  
  get rol_libelle(){
    return this.modified.ROL_LIBELLE!
  }
  set rol_libelle(value:string){    
    this.$store.myActions.ROLE_UPDATE_MODIFIED_ADM({
      ROL_LIBELLE:value
    })
  }

  get rol_key(){
    return this.modified.ROL_KEY!
  }
  set rol_key(value:string){    
    this.$store.myActions.ROLE_UPDATE_MODIFIED_ADM({
      ROL_KEY:value
    })
  }
}
</script>